<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img src="@/assets/admin-icon/customers-active.svg" />
          <pathViewer></pathViewer>
        </div>
        <div class="ribbon-options">
          <RoleManagement></RoleManagement>
        </div>
      </div>
      <div class="page-options">
        <button
          class="btn-option"
          :class="{ active: switch_tab == 'list' }"
          @click="selectTab('list')"
        >
          Accounts
        </button>
        <button
          class="btn-option"
          :class="{ active: switch_tab == 'contacts' }"
          @click="selectTab('contacts')"
        >
          Contacts
        </button>
      </div>
    </div>
    <div class="page-body">
      <!-- List -->
      <List v-if="switch_tab == 'list'"></List>
      <!-- Contacts -->
      <Contacts v-if="switch_tab == 'contacts'"></Contacts>
    </div>
  </div>
</template>
<script>
import List from "@/views/Accounts/List.vue";
import Contacts from "@/views/Accounts/Contacts.vue";
export default {
  name: "customer",
  components: {
    List,
    Contacts,
  },
  data() {
    return {
      switch_tab: "list",
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.switch_tab = val;
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Accounts",
      },
    ];
    vm.$store.commit("SET_PATH", path);
    if (vm.$route.params.type) {
      vm.switch_tab = vm.$route.params.type;
    }
  },
  methods: {
    selectTab(type) {
      let vm = this;
      let path = [
        {
          label: "Organization",
        },
        {
          label: type,
          active: true,
        },
      ];
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({
          name: "accounts",
          params: { type: type },
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  .page-header {
    height: 89px;
    background: #dfdfdf;
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;
      background: #fff;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      background: #d6d6d6;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 16px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }
  .page-body {
    overflow-y: auto;
    height: calc(100% - 89px);
  }
}
</style>
